<template>
    <modal name="document-folder-edit-modal"
        :adaptive="true"
        :focusTrap="true"
        :width="500"
        height="auto"
        :styles="{ boxShadow: 'none', background: 'transparent' }"
        @before-open="beforeOpen"
        @before-close="beforeClose"
    >
        <div class="rounded-lg bg-white p-8">
            <div class="flex flex-col mb-6">
                <div class="flex-shrink-0 text-blue-600 text-lg font-semibold leading-none mb-6">
                    Folder name:
                </div>

                <input type="folder_name"
                    class="flex-1 field text-base"
                    name="folder_name"
                    v-model="folder_name"
                    @keyup.enter="updateFolder"
                >
            </div>

            <div v-if="error" class="text-red-600 font-semibold text-sm leading-tight mb-0">
                {{ error }}
            </div>

            <div class="flex items-center justify-between pt-4">
                <button type="button"
                    class="flex items-center text-sm text-gray-600 hover:text-red-600 mr-4 leading-none"
                    @click="deleteFolder"
                >
                    <i class="far fa-trash-alt mr-2 mb-0.5"></i>

                    Delete Folder
                </button>

                <div class="flex items-center space-x-4">
                    <button-gray-outline @click="beforeClose">
                        Cancel
                    </button-gray-outline>

                    <button-blue @click="updateFolder">
                        Save
                    </button-blue>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import ButtonBlue from '../../components/button-blue.vue';
import ButtonGrayOutline from '../../components/button-gray-outline.vue';

export default {
    components: {
        ButtonBlue,
        ButtonGrayOutline,
    },

    props: {
        show: {},
        folder: {},
        property_id: {},
    },

    data() {
        return {
            folder_name: {},
            error: null,
        }
    },

    methods: {
        beforeOpen(event) {
            this.folder_name = this.folder.name;
        },
        beforeClose(event) {
            this.$emit('closed');
        },
        updateFolder() {
            if (! this.folder_name) {
                this.error = 'Please enter a folder name.';
                return;
            }

            this.error = null;

            axios.patch('/properties/' + this.property_id + '/document-folders/' + this.folder.id, {
                name: this.folder_name,
            }).then(response => {
                this.$emit('updatedFolder', response.data);
                this.$modal.hide('document-folder-edit-modal');
            }).catch(error => {
                this.error = error.response.data.message;
                console.log(error.response);
            });
        },
        deleteFolder() {
            this.error = null;

            axios.delete('/properties/' + this.property_id + '/document-folders/' + this.folder.id)
                .then(response => {
                    this.$emit('deletedFolder', this.folder);
                    this.$modal.hide('document-folder-edit-modal');
                }).catch(error => {
                    this.error = error.response.data.message;
                    console.log(error.response);
                });
        },
    },

    watch: {
        show(val) {
            if (val) {
                this.$modal.show('document-folder-edit-modal');
            } else {
                this.$modal.hide('document-folder-edit-modal');
            }
        },
    },
}
</script>

<style scoped>
.vm--overlay {
    background: #000000;
    opacity: 0.7;
}

.overlay-enter,
.overlay-leave-to {
    opacity: 0;
}

.overlay-enter-active,
.overlay-leave-active {
    transition: all .3s;
}
</style>
